import React from 'react'
import Manager from '../../public/components/Manager'
import SupplierDiv from './SupplierDiv'
Ext.require('Ext.Toast')


const config = ({ roles }) => {
    return{
        tabs: {
            申请中: {
                buttons: [
                    {
                        icon: 'plus', text: '添加...', handler: ({ showDetail, refreshPage }) =>
                            showDetail(props => <SupplierDiv {...props} id={0} />)
                    },
                ],
                columns: [
                    { _text: '供应商编号', field: 'Number', search: true, minWidth: 150/* , tools: tipTools */ },
                    { _text: '供应商名称', field: 'SupplierName', search: true, minWidth: 150, flex: 1, },
                    { _text: '公司地址', field: 'Address', search: true, minWidth: 150, flex: 1, },
                    { _date: '公司成立日期', field: 'IncorporationDate', minWidth: 150, flex: 1, },
                    { _text: '公司负责人', field: 'CompanyHead', search: true, minWidth: 150, flex: 1, },
                    { _text: '公司电话', field: 'CompanyTel', minWidth: 150, search: true, flex: 1, },
                    { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, },
                    { _datetime: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1, },
                ],
                onDoubleTap: ({ showDetail }, data) => showDetail(props => <SupplierDiv {...props} id={data.id} roles={roles}/>),
            },
            被退回: {
                buttons: [
                ],
                columns: [
                    { _text: '供应商编号', field: 'Number', search: true, minWidth: 150/* , tools: tipTools */ },
                    { _text: '供应商名称', field: 'SupplierName', search: true, minWidth: 150, flex: 1, },
                    { _text: '公司地址', field: 'Address', search: true, minWidth: 150, flex: 1, },
                    { _date: '公司成立日期', field: 'IncorporationDate', minWidth: 150, flex: 1, },
                    { _text: '公司负责人', field: 'CompanyHead', search: true, minWidth: 150, flex: 1, },
                    { _text: '公司电话', field: 'CompanyTel', minWidth: 150, search: true, flex: 1, },
                    { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, },
                    { _datetime: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1, },
                    { _text: '退回原因', field: 'Creator', minWidth: 150, flex: 1, },
                ],
                onDoubleTap: ({ showDetail }, data) => showDetail(props => <SupplierDiv {...props} id={data.id}  roles={roles} taskName="供应商新增退回申请" />),
            },
            待填写: {
                buttons: [
                ],
                columns: [
                    { _text: '供应商编号', field: 'Number', search: true, minWidth: 150/* , tools: tipTools */ },
                    { _text: '供应商名称', field: 'SupplierName', search: true, minWidth: 150, flex: 1, },
                    { _text: '公司地址', field: 'Address', search: true, minWidth: 150, flex: 1, },
                    { _date: '公司成立日期', field: 'IncorporationDate', minWidth: 150, flex: 1, },
                    { _text: '公司负责人', field: 'CompanyHead', search: true, minWidth: 150, flex: 1, },
                    { _text: '公司电话', field: 'CompanyTel', minWidth: 150, search: true, flex: 1, },
                    { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, },
                    { _datetime: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1, },
                ],
                onDoubleTap: ({ showDetail }, data) => showDetail(props => <SupplierDiv {...props} id={data.id} roles={roles}/>),
            },
            核对中: {
                buttons: [
                ],
                columns: [
                    { _text: '供应商编号', field: 'Number', search: true, minWidth: 150/* , tools: tipTools */ },
                    { _text: '供应商名称', field: 'SupplierName', search: true, minWidth: 150, flex: 1, },
                    { _text: '公司地址', field: 'Address', search: true, minWidth: 150, flex: 1, },
                    { _date: '公司成立日期', field: 'IncorporationDate', minWidth: 150, flex: 1, },
                    { _text: '公司负责人', field: 'CompanyHead', search: true, minWidth: 150, flex: 1, },
                    { _text: '公司电话', field: 'CompanyTel', minWidth: 150, search: true, flex: 1, },
                    { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, },
                    { _datetime: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1, },
                ],
                onDoubleTap: ({ showDetail }, data) => showDetail(props => <SupplierDiv {...props} id={data.id} roles={roles}/>),
            },
            已完成: {
                buttons: [
                ],
                columns: [
                    { _text: '供应商编号', field: 'Number', search: true, minWidth: 150/* , tools: tipTools */ },
                    { _text: '供应商名称', field: 'SupplierName', search: true, minWidth: 150, flex: 1, },
                    { _text: '公司地址', field: 'Address', search: true, minWidth: 150, flex: 1, },
                    { _date: '公司成立日期', field: 'IncorporationDate', minWidth: 150, flex: 1, },
                    { _text: '公司负责人', field: 'CompanyHead', search: true, minWidth: 150, flex: 1, },
                    { _text: '公司电话', field: 'CompanyTel', minWidth: 150, search: true, flex: 1, },
                    { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, },
                    { _datetime: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1, },
                ],
                onDoubleTap: ({ showDetail }, data) => showDetail(props => <SupplierDiv {...props} id={data.id} />),
            },
        }
    }

}

export default props => <Manager {...props} config={config} />